export default {"src":"/_next/static/media/tpay.01b075f0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};